module.exports = __webpack_public_path__ + "static/media/earth.a5f1f924.svg";